import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteDataProvider } from "./contexts/SiteDataContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Exhibitions from "./pages/Exhibitions";
import Shop from "./pages/Shop";
import Contact from "./pages/Contact";
import ArtworkDetail from "./pages/ArtworkDetail";
import CommissionRequest from "./pages/CommissionRequest";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteDataProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/commissions" element={<CommissionRequest />} />
              <Route path="/exhibitions" element={<Exhibitions />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/artwork/:id" element={<ArtworkDetail />} />
            </Routes>
          </Layout>
        </SiteDataProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
